var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_22237)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.8766 11.666C34.1166 11.666 14.0366 31.736 14.0366 56.506C14.0366 81.276 34.1166 101.346 58.8766 101.346C83.6366 101.346 103.717 81.266 103.717 56.506C103.717 31.746 83.6466 11.666 58.8766 11.666Z",
    fill: "url(#paint0_radial_164_22237)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1665 11.3848C31.6265 11.3848 10.9165 32.0848 10.9165 57.6348C10.9165 83.1848 31.6265 103.885 57.1665 103.885C82.7065 103.885 103.417 83.1748 103.417 57.6348C103.417 32.0948 82.7065 11.3848 57.1665 11.3848Z",
    fill: "url(#paint1_linear_164_22237)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1665 11.3848C31.6265 11.3848 10.9165 32.0848 10.9165 57.6348C10.9165 83.1848 31.6265 103.885 57.1665 103.885C82.7065 103.885 103.417 83.1748 103.417 57.6348C103.417 32.0948 82.7065 11.3848 57.1665 11.3848Z",
    fill: "#516CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1665 11.3848C31.6265 11.3848 10.9165 32.0848 10.9165 57.6348C10.9165 83.1848 31.6265 103.885 57.1665 103.885C82.7065 103.885 103.417 83.1748 103.417 57.6348C103.417 32.0948 82.7065 11.3848 57.1665 11.3848Z",
    fill: "url(#paint2_radial_164_22237)",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1665 11.3848C31.6265 11.3848 10.9165 32.0848 10.9165 57.6348C10.9165 83.1848 31.6265 103.885 57.1665 103.885C82.7065 103.885 103.417 83.1748 103.417 57.6348C103.417 32.0948 82.7065 11.3848 57.1665 11.3848Z",
    fill: "url(#paint3_radial_164_22237)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M57.1569 11.666C32.3869 11.666 12.3169 31.736 12.3169 56.506C12.3169 81.276 32.3969 101.346 57.1569 101.346C81.9169 101.346 102.007 81.266 102.007 56.506C102.007 31.746 81.9269 11.666 57.1569 11.666Z",
    fill: "url(#paint4_radial_164_22237)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_22237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5512 50.8355L78.4518 43.537C78.9247 43.2202 79.5767 43.3303 79.9077 43.7827C80.0306 43.9508 80.0967 44.151 80.0967 44.3562V68.5149C80.0967 69.0671 79.6285 69.5149 79.0512 69.5149C78.8367 69.5149 78.6274 69.4517 78.4518 69.3341L67.5512 62.0355V70.4355C67.5512 71.5401 66.6151 72.4355 65.4603 72.4355H36.1876C35.0328 72.4355 34.0967 71.5401 34.0967 70.4355V42.4355C34.0967 41.331 35.0328 40.4355 36.1876 40.4355H65.4603C66.6151 40.4355 67.5512 41.331 67.5512 42.4355V50.8355ZM67.5512 57.1529L75.9149 62.7529V50.1182L67.5512 55.7181V57.1529ZM38.2785 44.4355V68.4355H63.3694V44.4355H38.2785ZM42.4603 48.4355H46.6421V52.4355H42.4603V48.4355Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_22237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1667 12.6055C81.3767 12.6055 101.067 32.2955 101.067 56.5055C101.067 80.7155 81.3767 100.406 57.1667 100.406C32.9567 100.406 13.2667 80.7056 13.2667 56.5055C13.2667 32.3055 32.9567 12.6055 57.1667 12.6055ZM57.1667 7.43555C30.0667 7.43555 8.09668 29.4055 8.09668 56.5055C8.09668 83.6055 30.0667 105.576 57.1667 105.576C84.2667 105.576 106.237 83.6055 106.237 56.5055C106.237 29.4055 84.2667 7.43555 57.1667 7.43555Z",
    fill: "url(#paint5_linear_164_22237)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_22237",
    x: 32.0967,
    y: 40.4355,
    width: 50,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_22237",
    x: 4.09668,
    y: 7.43555,
    width: 106.14,
    height: 106.141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_164_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.607 59.2914) scale(50.3982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D0D6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3B5565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_22237",
    x1: 27.5265,
    y1: 22.1348,
    x2: 86.8165,
    y2: 93.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_164_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3262 30.6556) rotate(51.0441) scale(77.6487 77.6487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_164_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.7453 92.3223) rotate(-93.6705) scale(79.1728 88.2414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34499C",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_164_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0683 55.905) scale(43.9926 43.9926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BDD1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#719CB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0A5478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_164_22237",
    x1: 25.7167,
    y1: 18.8355,
    x2: 88.6167,
    y2: 94.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_22237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white",
    transform: "translate(0.833496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOption);
export default __webpack_public_path__ + "static/media/VideoOption.127ed955c91e863b11ee7e428b214039.svg";
export { ForwardRef as ReactComponent };